import * as React from 'react'

import LogicOperatorForm from 'modules/core/components/MultiFilters/Forms/LogicOperatorForm'
import MultiFilterForm from 'modules/core/components/MultiFilters/Forms/MultiFilterForm'
import { logicOperators } from 'modules/core/components/MultiFilters/hooks/utils/logicOperators'

export class AnalyticsFilterForm {
  filters: Array<MultiFilterForm['values']> = []
  logicOperator: Record<string, string> = {}
  default: Array<MultiFilterForm['values']> = []
  isActive = false

  constructor(
    filters: Array<MultiFilterForm['values']> = [],
    logicOperator: Record<string, string> = {},
    defaultFilter: Array<MultiFilterForm['values']> = [],
    isActive = false
  ) {
    this.filters = filters
    this.logicOperator = logicOperator
    this.default = defaultFilter
    this.isActive = isActive
  }
}

export default function useAnalyticsMultiFilters(
  setFilterHolder: (filterHolder: AnalyticsFilterForm) => void
) {
  const [localFilter, setLocalFilter] = React.useState<AnalyticsFilterForm>(
    new AnalyticsFilterForm([], { logic_operator: logicOperators.and }, [])
  )

  const initialFilters = () => {
    return localFilter.filters.map((local) => new MultiFilterForm(local)) || []
  }

  const [filters, setFilters] = React.useState<MultiFilterForm[]>(initialFilters())

  const logicOperator = React.useRef(
    new LogicOperatorForm(
      localFilter?.logicOperator || {
        logic_operator: logicOperators.and,
      }
    )
  ).current

  const onApplyFilters = async (isActive: boolean, defaultFilter?: MultiFilterForm[]) => {
    const defaultValues = defaultFilter?.[0]

    setLocalFilter({
      filters: filters.map((filter) => filter.values),
      logicOperator: logicOperator.values,
      default: defaultValues ? [defaultValues.values] : [],
      isActive: isActive,
    })
    setFilterHolder(
      new AnalyticsFilterForm(
        filters.map((filter) => filter.values),
        logicOperator.values,
        defaultValues ? [defaultValues.values] : [],
        isActive
      )
    )
  }

  const onCancel = () => {
    setFilters(initialFilters())
  }

  const onRemoveFilter = (index: number) => {
    setFilters(filters.filter((_, i) => i !== index))
  }

  const onAddFilter = () => {
    setFilters([...filters, new MultiFilterForm({})])
  }

  return {
    logicOperator,
    filters,
    onApplyFilters,
    onCancel,
    onRemoveFilter,
    onAddFilter,
    localFilter,
  }
}
